import { Paths, PathValue } from "@mctypes/global.types";
import React, { useEffect } from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../../components";
import { Radio, Paper, Stack, Title } from "@mantine/core";import {  IGKRapport,
  IGKRelativeFuktighetsmaalingResultater,
} from "../../../../../../../mc-shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../../ReportBoard/ReportDocxImageContainer";
import { beregnetDiffMellomToVerdier } from "../../gkGlobalUtils";
const RelativLuftfuktighetsMaaling: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKRelativeFuktighetsmaalingResultater;
}> = ({ data, onUpdateEditData }) => {
  // const UTSTYRSOPTIONS = ["Hygrometer I", "Hygrometer II"];
  useEffect(() => {
    utdataBeregninger();
  }, [data.inndata.maaleresultat]);
  const utdataBeregninger = () => {
    const relativLuftfuktighetDiff = beregnetDiffMellomToVerdier(
      data.inndata.settpunktsLuftfuktighet,
      data.inndata.maaleresultat,
    );
    const utdata = {
      relativLuftfuktighetDiff: relativLuftfuktighetDiff,
    };
    onUpdateEditData("testResultater.relativFuktighetsmaaling.utdata", utdata);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Relativ luftfuktighetsmåling</Title>
        <div className="d-flex flex-column mb-4">
          <McInputNew
            label="Fyll inn settpunktsfuktigheten (%):"
            value={data.inndata.settpunktsLuftfuktighet}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData(
                "testResultater.relativFuktighetsmaaling.inndata.settpunktsLuftfuktighet",
                Number(e.target.value),
              )
            }
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column">
          <McInputNew
            label="Fyll inn målt stabil relativ luftfuktighet (%):"
            value={data.inndata.maaleresultat}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData("testResultater.relativFuktighetsmaaling.inndata.maaleresultat", Number(e.target.value))
            }
            className="w-25"
          />
        </div>
        <div className="d-flex justify-content-between">
          <p className="mb-0">
            Relativ luftfuktighetsdifferanse &#40;%&#41; =
            <b>
              {" "}
              {beregnetDiffMellomToVerdier(data.inndata.settpunktsLuftfuktighet, data.inndata.maaleresultat)?.toFixed(
                2,
              ) ?? ""}
            </b>
          </p>
          <p className="mb-0">Formel: &#40;Diff RH = RHm - RHs&#41;</p>
        </div>
        <hr className="mt-0" />
        <div className="d-flex flex-column">
          <McInputNew
            label="Løpt tid til relativ luftfuktighet er stabil (s):"
            value={data.inndata.tidTilLuftfuktighetErStabil}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData(
                "testResultater.relativFuktighetsmaaling.inndata.tidTilLuftfuktighetErStabil",
                Number(e.target.value),
              )
            }
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-4">
          <div className="d-flex flex-column">
                        <Radio
              checked={data.inndata.godkjent === true}
              onChange={() => onUpdateEditData("testResultater.relativFuktighetsmaaling.inndata.godkjent", true)}
              label="Godkjent"
            />
                        <Radio
              checked={data.inndata.godkjent === false}
              onChange={() => onUpdateEditData("testResultater.relativFuktighetsmaaling.inndata.godkjent", false)}
              label="Ikke godkjent"
            />
          </div>
        </div>
        <div className="w-50 mt-4">
          <div>
            <ReportDocxImageContainer docxImageTag="relativFuktighetsmaaling" title="Målepunkter i rommet" />
          </div>
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) =>
              onUpdateEditData("testResultater.relativFuktighetsmaaling.inndata.kommentar", e.target.value)
            }
          />
        </div>
      </Stack>
    </Paper>
  );
};
export default RelativLuftfuktighetsMaaling;